// @core/stores/notifications/NotificationsAnalyticStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { notificationsApi } from '@core/api';
import type {
  GetDeliveryReportResponse,
  GetNotificationStatsResponse,
} from '@core/types/notifications';

class NotificationsAnalyticStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get delivery report for notification
   */
  async GetDeliveryReport(notification_id: string): Promise<GetDeliveryReportResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await notificationsApi.GetDeliveryReport(notification_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get notification statistics
   */
  async GetNotificationStats(params?: { }): Promise<GetNotificationStatsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await notificationsApi.GetNotificationStats(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const notificationsAnalyticStore = new NotificationsAnalyticStore();
